import React from "react";
import { colors } from "../../../../../../../../themes/Colors";
import AgencyItemDisplay from "../agency-item-display/AgencyItemDisplay";
import { BaseButtons } from "../../../../../../../common-components";

const AgencySelectPopUp = ({ display, title, setAddAgencyPop }) => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        flex: 1,
        display: "flex",
        backgroundColor: colors.white,
        height: display ? "100%" : 0,
        width: "100%",
        zIndex: 10000000000,
        right: 0,
        flexDirection: "column",
        overflow: "hidden",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          position: "absolute",
          top: -5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <BaseButtons
          label={"BACK"}
          width={"90%"}
          height={40}
          backgroundColor={colors.orangeDark}
          borderRadius={8}
          onClick={() => setAddAgencyPop(false)}
        />
      </div>
      <div
        style={{
          width: "90%",
          fontWeight: "bold",
          fontSize: 18,
          marginTop: 50,
          marginBottom: 10,
          textAlign: "center",
        }}
      >
        SELECT MANAGE AGENCY FOR {title}
      </div>
      <div
        style={{
          flex: 1,
          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "none",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ width: "90%", fontSize: 14, textAlign: "center" }}>
          SELECT AND VIEW AGENT YOU WOULD LIKE TO ASSISGN TO MANAGE YOUR VEHICLE
          TASK
        </div>
        <AgencyItemDisplay />
      </div>
    </div>
  );
};

export default AgencySelectPopUp;
